import Vue from 'vue'
import VueRouter from 'vue-router'
import Nav from '@/components/common/Head'
import $store from '@/store/index.js'

// 解决vue-router在3.0版本以上冗余导航报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'participate',
    components: {
      default: () => import('@/views/CheckVersion/index'),
      head: Nav
    }
  },
  {
    path: '/join',
    name: 'joinPage',
    components: {
      default: () => import('@/views/Join/index')
    }
  },
  {
    path: '/joinOrStart',
    name: 'joinOrStart',
    components: {
      default: () => import('@/views/JoinOrStart/JoinOrStart.vue')
    }
  },
  {
    path: '/preview',
    name: 'preview',
    components: {
      default: () => import('@/views/Preview/preview.vue')
    }
  },
  {
    path: '/speechBar',
    name: 'speechBar',
    components: {
      default: () => import('@/components/common/speechBar.vue')
    }
  },
  {
    path: '/manage',
    name: 'manage',
    components: {
      default: () => import('@/views/Manage/manage.vue')
    }
  },
  {
    path: '/plDebug',
    name: 'plDebug',
    components: {
      default: () => import('@/views/PlDebug/plDebug.vue')
    }
  },
  {
    path: '/transcript',
    name: 'transcript',
    components: {
      default: () => import('@/views/Email/summaryEmail.vue')
    }
  },
  {
    path: '/control',
    name: '',
    redirect: {
      name: 'party'
    },
    components: {
      default: () => import('@/views/Control/Index.vue'),
      head: Nav
    },
    children: [
      {
        path: 'party',
        name: 'party',
        components: {
          default: () => import('@/views/CommonParty/Host/index')
        }
      },
      {
        path: 'group',
        name: 'group',
        components: {
          default: () => import('@/views/GalleryView/Host')
        }
      },
      {
        path: 'coordinator',
        name: 'coordinator',
        components: {
          default: () => import('@/views/NewConference/Coordinator/index')
        }
      },
      {
        path: 'kiosk',
        name: 'kiosk',
        components: {
          default: () => import('@/views/KioskMode/Host/index.vue')
        }
      },
      {
        path: 'globalControl',
        name: 'globalControl',
        components: {
          default: () => import('@/views/GlobalControl/globalControl.vue'),
          head: Nav
        }
      },
      {
        path: 'intercom',
        name: 'intercom',
        components: {
          default: () => import('@/views/Intercom/index.vue'),
          head: Nav
        }
      },
      {
        path: 'newIntercom',
        name: 'newntercomPro',
        components: {
          default: () => import('@/views/Intercom/newIndex.vue'),
          head: Nav
        }
      }
    ]
  },
  {
    path: '/participate',
    name: '',
    components: {
      head: Nav,
      default: () => import('@/views/Participate/index.vue')
    },
    children: [
      {
        path: 'party',
        name: 'partyParticipate',
        components: {
          default: () => import('@/views/CommonParty/Participate/index')
        }
      },
      {
        path: 'channel',
        name: 'channelParticipate',
        components: {
          default: () => import('@/views/GalleryView/Participate/index.vue')
        }
      },
      {
        path: 'kiosk',
        name: 'kioskParticipate',
        components: {
          default: () => import('@/views/KioskMode/Participant/index.vue')
        }
      },
      {
        path: 'reporter',
        name: 'reporterParticipate',
        components: {
          default: () => import('@/views/NewConference/Participant/index.vue')
        }
      },
      {
        path: 'station',
        name: 'station',
        components: {
          default: () => import('@/views/Intercom/station.vue')
        }
      }
    ]
  },
  {
    path: '/partycode/:id',
    name: 'partycode',
    components: {
      default: () => import('@/views/redirectParty'),
      head: Nav
    }
  },
  {
    path: '/joinParty',
    name: 'joinParty',
    components: {
      default: () => import('@/views/JoinParty/index')
    }
  },
  {
    path: '/remove',
    name: 'remove',
    components: {
      default: () => import('@/views/Remove')
    }
  },
  {
    path: '/waitingList',
    name: 'waitingList',
    components: {
      default: () => import('@/views/CommonParty/Host/waitingList.vue'),
      head: Nav
    }
  },
  {
    path: '*',
    redirect: {
      name: 'joinOrStart'
    }
  },
  {
    path: '/collaborate',
    name: 'collaborate',
    components: {
      default: () => import('@/views/Collaborate/index.vue')
    },
    children: [
      {
        path: 'email',
        name: 'email',
        components: {
          default: () => import('@/views/Email/index.vue')
        }
      }
    ]
  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  mode: 'history',
  routes
})

router.beforeEach(async (to, from, next) => {
  const isWeixin = navigator.userAgent.includes('MicroMessenger')
  const { join_id, id, notNeedLoginInfo } = to.query
  const { passWord } = to.params
  const partyCode = join_id || id
  let hasLogin = false
  // 退出登录获取rotename
  if (to.path.includes('/participate')) { // 进入中转页面，会重新刷新页面，更新环境（cookie）
    await $store.dispatch('checkEnv', { partyCode, passWord })
  }

  if (to.name != 'joinOrStart') {
    await $store.dispatch('config')
    if (!notNeedLoginInfo) {
      hasLogin = await $store.dispatch('isLogin')
      $store.state.hasLogin = hasLogin
    }
  }

  if (!partyCode && !isWeixin && !hasLogin && to.path === '/') {
    next({
      name: 'joinOrStart'
    })
  } else {
    next()
  }
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  if (isChunkLoadFailed) {
    location.reload();
  }
})

export default router
